export const lightTheme = {
  body: "#F8F8F8",
  text: "#333",
  textColor: "#0b4495",
  textColorInverse: "#fff",
  linkColor: "royalblue",
  bgColor: "#333",
  bgColorInverse: "#fff",
  bgColorGrad: "-webkit-linear-gradient(315deg, #2a2a72 0%, #009ffd 74%)",
  footerText: "#313131",
  bgColorOp: "#E9E7E8",
  borderColor: "#0b4495",
  btnBgColor: "#0148C6",
  btnBgColorOp: "rgb(1, 72, 198, .9)",
  bgtext: "-webkit-linear-gradient(#333 60%, #333)",
  repoBg: "#E9E7E8",
  repoBorder: ""
};

export const darkTheme = {
  body: "#0C0C0C",
  text: "#fff",
  textColor: "#0b4495",
  textColorInverse: "#000",
  linkColor: "royalblue",
  bgColor: "#F8F8F8",
  bgColorInverse: "#fff",
  bgColorGrad: "-webkit-linear-gradient(315deg, #2a2a72 0%, #009ffd 74%)",
  bgColorOp: "#1D1D1D",
  borderColor: "#0b4495",
  btnBgColor: "#0148C6",
  btnBgColorOp: "rgb(1, 72, 198, .9)",
  bgtext:
    "-webkit-linear-gradient(top, rgb(255, 255, 255) 60%, rgb(51, 51, 51)) ;",
  repoBg: "#1D1D1D",
  repoBorder: "none"
};
